import type { ReactNode } from "react";

import {
  Dialog,
  DialogBackdrop,
  DialogPanel,
  DialogTitle,
} from "@headlessui/react";

import { Button, Spinner } from "@alpacahq/ui/old";

export interface PDFAgreementModalProps {
  isOpen: boolean;
  onCancel: () => void;
  onAgree: () => void;
  hasAgreed: boolean;
  title: string;
  url: string;
  disclosure?: ReactNode;
  isSubmitting?: boolean;
  isPreviewLoading?: boolean;
}

export const PDFAgreementModal = ({
  isOpen,
  onCancel,
  onAgree,
  hasAgreed,
  title,
  url,
  disclosure,
  isSubmitting,
  isPreviewLoading,
}: PDFAgreementModalProps) => (
  <Dialog
    open={isOpen}
    onClose={onCancel}
    className="relative z-50 min-h-[800px] overflow-y-auto"
  >
    <DialogBackdrop
      transition
      className="fixed inset-0 bg-black/30 duration-300 ease-out data-closed:opacity-0"
    />
    <div className="fixed inset-0 w-screen overflow-y-auto p-4">
      <div className="flex min-h-full items-center justify-center">
        <DialogPanel
          transition
          className="w-full max-w-[800px] rounded border border-gray-200 bg-white px-0 py-2 duration-300 ease-out data-closed:scale-95 data-closed:opacity-0"
        >
          <DialogTitle className="px-4 font-semibold text-gray-800 text-lg">
            {title}
          </DialogTitle>
          {isPreviewLoading ? (
            <div className="flex h-[500px] items-center justify-center border-gray-300 border-y">
              <Spinner />
            </div>
          ) : (
            <iframe
              id={title}
              title={title}
              height="500px"
              width="100%"
              src={url || "about:blank"}
              className="h-[500px] max-h-96 overflow-y-auto border-gray-300 border-y px-4 pt-4"
              style={{ scrollBehavior: "smooth" }}
            />
          )}
          <div className="mt-2 px-4">
            {disclosure && <div className="mb-3">{disclosure}</div>}
            {hasAgreed ? (
              <Button
                className="ml-auto"
                variant="v2/stroke"
                onClick={onCancel}
              >
                Close
              </Button>
            ) : (
              <div className="flex justify-end gap-4">
                <Button variant="v2/stroke" onClick={onCancel}>
                  Cancel
                </Button>
                <Button
                  variant="v2/filled"
                  onClick={onAgree}
                  loading={isSubmitting}
                  disabled={isPreviewLoading}
                >
                  I Agree
                </Button>
              </div>
            )}
          </div>
        </DialogPanel>
      </div>
    </div>
  </Dialog>
);
